// 참고
// --------------------
// RECITATION = '(구)인증제',
// JEBS_AI_RECITATION = 'AI 인증제',
// JEBSON = '젭스온',
// JEBSPL = '젭스플',
// WMW = 'WMW',
// JS1 = 'JS1',
// JS2 = 'JS2',
// HF = 'HF',
// HJ = 'HJ',
// --------------------

export enum AssignmentType {
  RECITATION = 'RECITATION',
  JEBS_AI_RECITATION = 'JEBS_AI_RECITATION',
  EXAM = 'EXAM',
  JEBSON = 'JEBSON',
  JEBSPL = 'JEBSPL',
  SURVEY = 'SURVEY',
  // 젭스플 과목
  HF = 'HF',
  HJ = 'HJ',
  JS1 = 'JS1',
  JS2 = 'JS2',
  WMW = 'WMW',
  // 젭스온 과목 (JEBSON은 레거시 통합 타입, 아래 3개가 과목별 타입)
  EC = 'EC', // English Creative / English Correct (잉크 / 잉코)
  EF = 'EF', // English Formula (잉포)
  ESB = 'ESB', // English Story Bible (잉스바)
  // 녹음 전용 과제 (암송 등)
  RECORDING = 'RECORDING',
}

export enum AssignmentStatusType {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  CLOSED = 'CLOSED',
  PROCESSING_RESULT = 'PROCESSING_RESULT',
}

export enum CourseId {
  KIDS = 'QJhUDePfAn__Y6na', // 영어교실 키즈
  BASIC = 'Irmk2AAW2RWV-iHn', // 영어교실 베이직
  ADVANCED = 'XoaJAz_Vg6fJ1QxQ', // 영어교실 어드밴스드
  HFHJ = 'GXHrE6RAfYafHfgs', // HFHJ
  WMW = 'VY6Yl4kxQsb3sYJZ', // WMW
}

export const SUBJECT_LABEL_MAP: Partial<Record<AssignmentType, string>> = {
  ESB: '잉스바',
  EF: '잉포',
  EC: '잉크',
  JEBS_AI_RECITATION: 'AI\n인증제',
  HF: 'HF',
  HJ: 'HJ',
  JS1: 'JS1',
  JS2: 'JS2',
  WMW: 'WMW',
};

export const SUBJECT_COLOR_MAP: Partial<Record<AssignmentType, string>> = {
  ESB: 'bg-[#FCE8EE] text-black text-sm border border-gray3',
  EF: 'bg-[#D8EFF9] text-black text-sm border border-gray3',
  EC: 'bg-[#FCFCE7] text-black text-sm border border-gray3',
  JEBS_AI_RECITATION: 'bg-[#FCFCE7] text-black text-xs border border-gray3',
  HF: 'bg-[#FCE8EE] text-black text-sm border border-gray3',
  HJ: 'bg-[#D8EFF9] text-black text-sm border border-gray3',
  JS1: 'bg-[#FCE8EE] text-black text-sm border border-gray3',
  JS2: 'bg-[#D8EFF9] text-black text-sm border border-gray3',
  WMW: 'bg-[#FCFCE7] text-black text-xs border border-gray3',
};

export const ASSIGNMENT_STATUS_LABEL_MAP: Record<AssignmentStatusType, string> =
  {
    [AssignmentStatusType.COMPLETED]: '완료',
    [AssignmentStatusType.IN_PROGRESS]: '진행 중',
    [AssignmentStatusType.NOT_STARTED]: '진행 전',
    [AssignmentStatusType.CLOSED]: '종료',
    [AssignmentStatusType.PROCESSING_RESULT]: '결과 처리 중',
  };

export enum LmsLinkItemKey {
  MATERIAL_VIEW = 'MATERIAL_VIEW',
  TODO_ASSIGN = 'TODO_ASSIGN',
  TODO_STATUS = 'TODO_STATUS',
  AI_RECITATION_ASSIGN = 'AI_RECITATION_ASSIGN',
  AI_RECITATION_STATUS = 'AI_RECITATION_STATUS',
  VOUCHER_MANAGE = 'VOUCHER_MANAGE',
  DALANT_MANAGE = 'DALANT_MANAGE',
  STUDENT_MANAGE = 'STUDENT_MANAGE',
  ARCHIVE_MANUAL = 'ARCHIVE_MANUAL',
  ARCHIVE_CAFE = 'ARCHIVE_CAFE',
  LMS_GUIDE = 'LMS_GUIDE',
  CLASS_GROUP_MANAGE = 'CLASS_GROUP_MANAGE',
}

export type LmsLinkItem = {
  courseId: string;
  itemKey: LmsLinkItemKey;
  link: string | null;
  notice: string | null;
  composition: string | null;
  updatedAt: string | null;
};

export const VOUCHER_TYPE_LABEL_MAP: Record<AssignmentType, string> = {
  ESB: '잉스바',
  EF: '잉포',
  EC: '잉크',
  JEBS_AI_RECITATION: 'AI 인증제',
  HF: 'HF',
  HJ: 'HJ',
  JS1: 'JS1',
  JS2: 'JS2',
  WMW: 'WMW',
  RECITATION: '인증제',
  EXAM: '시험',
  JEBSON: '젭스온',
  JEBSPL: '젭스플',
  SURVEY: '설문',
  RECORDING: '녹음',
};
